import axios from '../utils/axios';

export default function addSeekerPlan(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/createorder`, body);
};